import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { INVESTMENTS_PORTFOLIOS } from '@/common/paths';
import {
  Investment,
  InvestmentDto,
  InvestmentHoldingStatus,
  SearchInvestmentPortfoliosParams,
} from '@/modules/investments/investments.types';

const QUERY_KEY = 'InvestmentPortfolios';

const HTTPS_PREFIX = 'https://';
const HTTP_PREFIX = 'http://';

export const getResearchLink = (link: string) => {
  let formattedLink = link || '';
  if (formattedLink && !formattedLink.includes(HTTPS_PREFIX) && !formattedLink.includes(HTTP_PREFIX)) {
    formattedLink = `${HTTP_PREFIX}${formattedLink}`;
  }
  return formattedLink;
};

export const useInvestmentPortfolios = (searchParams: SearchInvestmentPortfoliosParams) => {
  const { isLoading, data, isSuccess, refetch } = useQuery(
    [QUERY_KEY, searchParams],
    () =>
      api.get<InvestmentDto[]>(INVESTMENTS_PORTFOLIOS, {
        params: { ...searchParams },
      }),
    {
      cacheTime: 4,
      retry: 0,
      enabled: !!searchParams?.investor_id,
    }
  );

  const formatedData = useMemo<Investment[]>(() => {
    const receivedData = data?.data || [];
    if (searchParams.isOnlyActive) {
      // item.status
      const list = receivedData.map((listItem) => ({
        election: listItem.election,
        amount: listItem.amount,
        fundName: listItem.fund_name,
        researchUrl: getResearchLink(listItem.research_url || ''),
        imageUrl: listItem.image_url || '',
        type: listItem.type,
        symbol: listItem.symbol,
        status: listItem.status,
        instrumentId: listItem.instrument_id,
      }));
      const filtered = list.filter((item) => item.status !== InvestmentHoldingStatus.Inactive);
      return filtered;
    }
    return receivedData.map((listItem) => ({
      election: listItem.election,
      amount: listItem.amount,
      fundName: listItem.fund_name,
      researchUrl: getResearchLink(listItem.research_url || ''),
      imageUrl: listItem.image_url || '',
      type: listItem.type as string,
      symbol: listItem.symbol,
      status: listItem.status,
      instrumentId: listItem.instrument_id,
    }));
  }, [data?.data, searchParams.isOnlyActive]);
  return {
    data: formatedData || [],
    isLoading,
    isSuccess,
    refetch,
  };
};
